<div class="business-pin-desk">
	<div>
		<div class="m-t-32">
			<app-kamona-phone-number-field [input]="phoneNumber">
			</app-kamona-phone-number-field>
		</div>
		<div class="m-t-32">
			<app-kamona-password-input [input]="password">
			</app-kamona-password-input>
		</div>
	</div>
	<div class="m-t-25" nz-row>
		<div nz-col nzSpan="24">
			<div class="kamona-button-session">
				<app-kamona-custom-button (submitForm)="submit()" [isBlock]="true" [isDisabled]="!form.valid"
										  text="Next">
				</app-kamona-custom-button>
			</div>
		</div>
	</div>

</div>
